import { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PHONE = "9654399019";
const WHATSAPP_URL = `https://wa.me/91${PHONE}?text=I%20am%20looking%20for%20-%20Chair%20Lift%20Quote`;
const CALL_URL = `tel:+91${PHONE}`;

const trackWhatsAppClick = () => {
  if (window.gtag) {
    window.gtag('event', 'conversion', {'send_to': 'AW-1013517818/RxIyCOi1naQYEPqbpOMD'});
  }
};

const trackCallClick = (url) => {
  if (window.gtag_report_conversion) {
    window.gtag_report_conversion(url);
  }
};

const STATES = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat","Haryana",
  "Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur",
  "Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana",
  "Tripura","Uttar Pradesh","Uttarakhand","West Bengal","Andaman and Nicobar Islands","Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu","Delhi","Jammu and Kashmir","Ladakh","Lakshadweep","Puducherry"
];

const PRODUCTS = [
  "Outdoor Chair Lift","Indoor Chair Lift","Straight Chair Lift","Curved Chair Lift","Wheelchair Platform Lift"
];

export { PHONE, WHATSAPP_URL, CALL_URL, STATES, PRODUCTS, API, trackWhatsAppClick, trackCallClick };

export function useLeadForm() {
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", state: "", product: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const updateField = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const submitForm = async (e) => {
    if (e) e.preventDefault();
    if (!form.full_name || !form.phone) {
      setError("Please enter your name and phone number.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/leads`, form);
      setSubmitted(true);
      setForm({ full_name: "", email: "", phone: "", state: "", product: "", message: "" });
      // Google Ads conversion tracking (enhanced with user data)
      if (window.gtag_report_form_conversion) {
        window.gtag_report_form_conversion(form.email, form.phone);
      }
    } catch (err) {
      setError("Something went wrong. Please try again or call us directly.");
    } finally {
      setLoading(false);
    }
  };

  return { form, updateField, submitForm, loading, submitted, setSubmitted, error };
}
